import React from 'react';

import { Segment, Icon } from '@mairistem/composants';

interface BlocTileProps {
  children?: React.ReactNode;
  title: string;
  stats?: string | number;
  onClick?: () => void;
  statsColor?: string;
  textColor?: string;
  style?: React.CSSProperties;
  icon?: string;
}
const BlocTile = (props: BlocTileProps) => {
  const {
    children,
    title,
    stats,
    onClick,
    statsColor,
    textColor,
    style,
    icon,
  } = props;

  const [hover, setHover] = React.useState(false);

  const handleNavigateToLink = () => {
    if (onClick) {
      onClick();
    }
  };

  const segmentStyle = {
    backgroundColor: '#f9f9f9',
    border: 'none',
    boxShadow: 'none',
    margin: 0,
    flex: 1,
  };

  const clickableSegmentStyle = {
    ...segmentStyle,
    cursor: 'pointer',
    transition: 'transform 0.2s, box-shadow 0.2s',
    transform: hover ? 'scale(1.02)' : 'scale(1)',
    boxShadow: hover ? '0 12px 30px rgba(0, 0, 0, 0.18)' : 'none',
  };

  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
  };

  const badgeStyle: React.CSSProperties = {
    fontWeight: '600',
    fontSize: '2em',
    padding: '10px',
    borderRadius: '4px',
    minWidth: '60px',
    textAlign: 'center',
  };

  const titleStyle = {
    fontWeight: '600',
    textDecoration: onClick ? 'underline' : 'none',
  };

  return (
    <Segment
      style={{
        ...style,
        ...clickableSegmentStyle,
        cursor: onClick ? 'pointer' : 'default',
        position: 'relative',
        padding: '1.2em 3em 1.2em 1.2em',
      }}
      onMouseEnter={() => onClick && setHover(true)}
      onMouseLeave={() => onClick && setHover(false)}
      onClick={onClick ? handleNavigateToLink : undefined}
    >
      {onClick && (
        <div
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            backgroundColor: 'white',
            borderRadius: '6px',
            padding: '6px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Icon
            name={(icon as any) || 'list'}
            iconSet={icon ? 'Lucide' : undefined}
            color={textColor || undefined}
            style={{
              color: textColor || undefined,
            }}
            // @ts-expect-error Type error
            size="1.2em"
          />
        </div>
      )}
      <div style={containerStyle}>
        <span
          style={{
            ...badgeStyle,
            color: textColor || `color-mix(in srgb, ${statsColor}, black 40%)`,
            backgroundColor: statsColor,
          }}
        >
          {stats ?? 1000}
        </span>
        <div style={titleStyle}>{title}</div>
      </div>
      {children}
    </Segment>
  );
};

export default BlocTile;
